/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClockOffsetDateTimeRequest
 */
export interface UpdateClockOffsetDateTimeRequest {
    /**
     * 
     * @type {Date}
     * @memberof UpdateClockOffsetDateTimeRequest
     */
    newDate: Date;
}

/**
 * Check if a given object implements the UpdateClockOffsetDateTimeRequest interface.
 */
export function instanceOfUpdateClockOffsetDateTimeRequest(value: object): value is UpdateClockOffsetDateTimeRequest {
    if (!('newDate' in value) || value['newDate'] === undefined) return false;
    return true;
}

export function UpdateClockOffsetDateTimeRequestFromJSON(json: any): UpdateClockOffsetDateTimeRequest {
    return UpdateClockOffsetDateTimeRequestFromJSONTyped(json, false);
}

export function UpdateClockOffsetDateTimeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClockOffsetDateTimeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newDate': (new Date(json['newDate'])),
    };
}

export function UpdateClockOffsetDateTimeRequestToJSON(value?: UpdateClockOffsetDateTimeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'newDate': ((value['newDate']).toISOString().substring(0,10)),
    };
}

